import React from 'react'
import cx from 'classnames'
import './styles.css'

const Footer = () => (
  <footer className={cx('blog-footer')}>
    <p>Copyright © {(new Date()).getFullYear()} - Nikhil Mohan</p>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/client/components/footer/index.js